import { isTruthy } from './helpers';

const isAccountScoped = scope => scope === 'account';
const isBrandScoped = scope => scope === 'brand';
// const isBridgAdmin = user => isTruthy(user) && isTruthy(user.scope) && user.scope === 'bridg';
const isBridgAdmin = user => isTruthy(user) && user.user_roles?.includes('BRIDG_ADMIN');
const isBrandAdmin = user => isTruthy(user) && user.user_roles?.includes('BRAND_ADMIN');
const isFranchiseeScoped = scope => scope === 'franchisee';
const isLocalScoped = scope => scope === 'localstore';
const isNotBridgAdmin = user => isTruthy(user) && user.scope && isTruthy(user.scope) && user.scope !== 'bridg';
const isRestrictedScope = user => {
  return (
    isTruthy(user) &&
    isTruthy(user.scope) &&
    (isBrandScoped(user.scope) || isFranchiseeScoped(user.scope) || isLocalScoped(user.scope))
  );
};

export {
  isAccountScoped,
  isBrandScoped,
  isBridgAdmin,
  isBrandAdmin,
  isFranchiseeScoped,
  isLocalScoped,
  isNotBridgAdmin,
  isRestrictedScope,
};
